import * as React from 'react';
import ListContainer from '../ListContainer';
import ExpandIcon from '../Utils/ExpandIcon';
import { ConfigurableItemDto } from '../ListItem';
import { ConfigureSectionDto } from '../AccordionContainer';
import { StyledAccordionContainer } from '../ConfigurePage.styles';
import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';

export interface GeneralSectionDto {
    name: string;
    pagination: ConfigurableItemDto;
    logoutTimeout: ConfigurableItemDto;
    calendarTimeFrame: ConfigurableItemDto;
}

interface GeneralSectionProps {
    dto: GeneralSectionDto;
    isExpanded: boolean;
    expandedPanels: string[];
    onExtendedPanelsChange: (isExpanded: boolean, panel: string) => void;
}

const GeneralSection = (props: GeneralSectionProps) => {
    const { name, pagination, logoutTimeout, calendarTimeFrame } = props.dto;
    const { onExtendedPanelsChange, isExpanded, expandedPanels } = props;

    //Data from dto
    const configurableItems: ConfigurableItemDto[] = [pagination, logoutTimeout, calendarTimeFrame];
    const innerSections: ConfigureSectionDto[] = [];

    return (
        <StyledAccordionContainer
            expanded={isExpanded}
            disableGutters={true}
            onChange={(_: unknown, isExpanded: boolean) =>
                onExtendedPanelsChange(isExpanded, name)
            }>
            <AccordionSummary expandIcon={<ExpandIcon isExpanded={isExpanded} />}>
                <Typography variant="h3">{name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <ListContainer
                    parentPanel={name}
                    expandedPanels={expandedPanels}
                    handleChange={onExtendedPanelsChange}
                    configurableItems={configurableItems}
                    innerSections={innerSections}
                />
            </AccordionDetails>
        </StyledAccordionContainer>
    );
};

export default GeneralSection;
